import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TokenService } from '../services/token.service';

export const authGuard = (): CanActivateFn => (_route, state) => {
  const router = inject(Router);
  const tokenService = inject(TokenService);
  const queryParams = router.parseUrl(state.url).queryParams;
  const isCookieBasedLogin =
    queryParams['isCookiesLogin'] === 'true' ||
    queryParams['isCookiesLogin'] === true;

  if (isCookieBasedLogin) {
    tokenService.setCookiesLogin(true);
    return true;
  }

  if (tokenService.isAuthenticated()) {
    return true;
  }

  router.navigate(['auth/login']);
  return false;
};
